module.exports = __webpack_public_path__ + "static/media/drive_moto2.59b46f7b.jpg";